import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { RxExternalLink } from 'react-icons/rx';
import { toast } from 'react-toastify';
import { mask, unMask } from 'remask';
import AppCard from '../../../../components/appCard';
import { useInfo } from '../../../../context/infoContext';
import { Api } from '../../../../services/api';
import { isAssociado, userInfo } from '../../../../services/authHandlers';
import { ButtonPagueDefault, PasswordFullPague } from '../../../../styles/primeReactConfig';
import Base64ToPDF from '../../../../utils/Base64ToPDF';

export const Perfil = () => {
  const {
    providerInfo,
    associadoInfo,
  } = useInfo();

  const { control, register, handleSubmit, setValue } = useForm({
      defaultValues: {
        tipo_empresa: '',
        usuario_documento: '',
        usuario_email: '',
        usuario_nome: '',
        nome_fantasia: '',
        usuario_telefone: '',
        usuario_id: '',
        usuario_senha: '',
        confirma_usuario_senha: '',
      }
    });

  const {
    control: control2,
    register: register2,
    handleSubmit: handleSubmit2,
    setValue: setValue2,
  } = useForm({
    defaultValues: {
      associado_documento: '',
      associado_email: '',
      associado_nome: '',
      password: '',
      confirm_password: '',
    }
  });

  const [loadingUser, setLoadingUser] = useState(false);
  const [loadingProvider, setLoadingProvider] = useState(false);

  function UpdateProviderInfo(values) {
    if (values.usuario_senha === values.confirma_usuario_senha) {
      setLoadingProvider(true);
      UpdateProvider(values);
    }
    else toast.warning("As senhas informadas estão diferentes! A senha de confirmação deve ser igual a nova senha desejada!")
  }

  useEffect(() => {
    const { personal } = providerInfo
    //console.log(personal,associadoInfo)
    if (Object.keys(personal).length > 0) {
      setValue("tipo_empresa", personal.tipo_empresa)
      setValue("usuario_documento", mask(personal.usuario_documento, ['999.999.999-99', '99.999.999/9999-99']))
      setValue("usuario_email", personal.usuario_email)
      setValue("usuario_nome", personal.usuario_nome)
      setValue("nome_fantasia", personal.nome_fantasia)
      setValue("usuario_telefone", mask(personal.usuario_telefone, '(99) 99999-9999'))
      setValue("usuario_id", personal.usuario_id)
    }
      
    if (Object.keys(associadoInfo).length > 0) {
      setValue2("associado_documento", mask(associadoInfo.associado_documento, ['999.999.999-99', '99.999.999/9999-99']))
      setValue2("associado_email", associadoInfo.associado_email)
      setValue2("associado_nome", associadoInfo.associado_nome)
    }
  }, [providerInfo])

  async function UpdateProvider(values) {
    const  {
      usuario_senha,
      tipo_empresa,
      usuario_email,
      usuario_nome,
      usuario_id,
    } = values

    const usuario_documento = unMask(values.usuario_documento, ["999.999.999-99", "99.999.999/9999-99"])
    const usuario_telefone = unMask(values.usuario_telefone, ['(99) 9999-9999', '(99) 99999-9999'])

    try {
      await Api.put('/users/update-all', {
        password:usuario_senha,
        tipo_empresa,
        usuario_documento,
        usuario_email,
        usuario_nome,
        usuario_telefone,
        usuario_id,
      })
      toast.success("Dados atualizados com sucesso");
    } catch (error) {
      if(error && error.response)
        console.log(error.response)
    }
    finally {
      setLoadingProvider(false)
    }
  }

  async function buscaContrato() {
    try {

      const { data } = await toast.promise(Api.get(`users/contratos/${userInfo.usuario_id}`),
        {
          pending: "Buscando encontratos",
          success: "Contratos encontrados :)",
          error: "Nenhum contrato encontrado :("
        })
      for (let contrato_base64 of data) {
        Base64ToPDF(contrato_base64.base64, contrato_base64.nome)
      }
    } catch (error) {
      if(error && error.response)
        console.log(error.response)
    }
  }

  function UpdatePersonalInfo(values) {
    if (values.password === values.confirm_password) {
      setLoadingUser(true);
      UpdateUser(values);
    }
    else toast.warning("As senhas informadas estão diferentes! A senha de confirmação deve ser igual a nova senha desejada!")
  }

  async function UpdateUser(values) {
    const  {
      password,
      associado_email,
      associado_nome,
    } = values
    const associado_senha = password
    const associado_documento = unMask(values.associado_documento, ["999.999.999-99", "99.999.999/9999-99"])

    try {
      await Api.put(`/associados/dadosassociados/${associadoInfo.associado_id}`, {
        associado_senha,
        associado_documento,
        associado_email,
        associado_nome,
      })
      toast.success("Dados atualizados com sucesso");
    } catch (error) {
      if(error && error.response)
      console.log(error);
    }
    finally {
      setLoadingUser(false);
    }
  }





  return (<>
    
    <div className='grid gap-6'>
      {isAssociado && (
        <AppCard >
          <form onSubmit={handleSubmit2(UpdatePersonalInfo)}>
            <div className="grid w-full gap-4">
              <h4 className='text-xl'><b>Dados do Usuário</b></h4>
              <div className="grid grid-cols-1 md:grid-cols-2 w-full">
                <div className="grid md:flex p-2 items-center">
                  <label htmlFor="associado_nome" className="w-full mb-2 md:w-1/4 md:mb-0">Nome</label>
                  <div className="w-full md:w-3/4 grid">
                    <InputText
                      {...register2("associado_nome")}
                      id="associado_nome"
                    />
                  </div>
                </div>
                <div className="grid md:flex p-2 items-center">
                  <label htmlFor="password" className="w-full mb-2 md:w-1/4 md:mb-0">Senha</label>
                  <div className="w-full md:w-3/4">
                    <Controller
                      name="password"
                      control={control2}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <Password
                          toggleMask
                          pt={PasswordFullPague}
                          feedback={false}
                          value={value}
                          required
                          onChange={(e) => onChange(e.target.value)}
                          id="password"
                        />)}
                    />
                  </div>
                </div>
                <div className="grid md:flex p-2 items-center">
                  <label htmlFor="associado_email" className="w-full mb-2 md:w-1/4 md:mb-0">Email</label>
                  <div className="w-full md:w-3/4 grid">
                    <InputText
                      {...register2("associado_email")}
                      id="associado_email"
                    />
                  </div>
                </div>
                <div className="grid md:flex p-2 items-center">
                  <label htmlFor="confirm_password" className="w-1/2 mb-2 md:w-1/4 md:mb-0">Confirmar Senha</label>
                  <div className="w-full md:w-3/4">
                    <Controller
                      name="confirm_password"
                      control={control2}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <Password
                          toggleMask
                          pt={PasswordFullPague}
                          feedback={false}
                          value={value}
                          required
                          onChange={(e) => onChange(e.target.value)}
                          id="confirm_password"
                        />)}
                    />
                  </div>
                </div>
                <div className="grid md:flex p-2 items-center">
                  <label htmlFor="associado_documento" className="w-full mb-2 md:w-1/4 md:mb-0">Documento</label>
                  <div className="w-full md:w-3/4 grid">
                    <Controller
                      name="associado_documento"
                      control={control2}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <InputText
                          value={value}
                          onChange={({ target }) =>
                            onChange(
                              mask(unMask(target.value), [
                                '999.999.999-99',
                                '99.999.999/9999-99'
                              ])
                            )
                          }
                          id="associado_documento"
                          type="text"
                        />)}
                    />
                  </div>
                </div>
              </div>
              <div className="flex w-full justify-center">
                <div className="w-full md:w-3/4 lg:w-1/3">
                  <Button
                    className="w-full"
                    pt={ButtonPagueDefault}
                    label="Enviar"
                    type="submit"
                    loading={loadingUser}
                  ></Button>
                </div>
              </div>
            </div>
          </form>

        </AppCard>
      )}
      {(userInfo.super_usuario ||
        associadoInfo.associado_tipo === "M" ||
        associadoInfo.associado_tipo === "A" ||
        !isAssociado) &&
        (<AppCard >
          <form onSubmit={handleSubmit(UpdateProviderInfo)}>
            <div className="grid w-full gap-4">
              <div className='flex justify-between'>
                <div className='text-xl'>
                  <h4><b>Dados do Cliente</b></h4>
                </div>
                <a
                  onClick={() => buscaContrato()}
                  target="_blank"
                  className='cursor-pointer'
                  rel="noreferrer"
                  style={{ marginRight: '65px' }}
                >
                  <div
                    className='flex px-5 py-1'
                    style={{ backgroundColor: '#253aaf', borderRadius: 30, alignItems: 'center', color: 'white' }}
                  >
                    <div>
                      {/* <img className='mx-2' src={iconWhats} alt="direto-logo" style={{ height: '20px', width: "auto" }} ></img> */}
                      <p
                        className="font-lato text-sm"
                      >
                        Termos e condições
                      </p>
                    </div>
                    <div className='ml-2'>
                      <RxExternalLink/>
                    </div>
                  </div>
                </a>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 w-full">
                <div className="grid md:flex p-2 items-center">
                  <label htmlFor="usuario_nome" className="w-full mb-2 md:w-1/4 md:mb-0">Nome</label>
                  <div className="w-full md:w-3/4 grid">
                    <InputText
                      {...register("usuario_nome")}
                      id="usuario_nome"
                    />
                  </div>
                </div>
                <div className="grid md:flex p-2 items-center">
                  <label htmlFor="nome_fantasia" className="w-full mb-2 md:w-1/4 md:mb-0">Nome Fantasia</label>
                  <div className="w-full md:w-3/4 grid">
                    <InputText
                      {...register("nome_fantasia")}
                      id="nome_fantasia"
                    />
                  </div>
                </div>
                <div className="grid md:flex p-2 items-center">
                  <label htmlFor="usuario_email" className="w-full mb-2 md:w-1/4 md:mb-0">Email</label>
                  <div className="w-full md:w-3/4 grid">
                    <InputText
                      {...register("usuario_email")}
                      id="usuario_email"
                    />
                  </div>
                </div>
                <div className="grid md:flex p-2 items-center">
                  <label htmlFor="usuario_documento" className="w-full mb-2 md:w-1/4 md:mb-0">Documento</label>
                  <div className="w-full md:w-3/4 grid">
                    <Controller
                      name="usuario_documento"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <InputText
                          value={value}
                          disabled
                          onChange={({ target }) =>
                            onChange(
                              mask(unMask(target.value), [
                                '999.999.999-99',
                                '99.999.999/9999-99'
                              ])
                            )
                          }
                          id="usuario_documento"
                          type="text"
                        />)}
                    />
                  </div>
                </div>
                <div className="grid md:flex p-2 items-center">
                  <label htmlFor="usuario_telefone" className="w-full mb-2 md:w-1/4 md:mb-0">Contato</label>
                  <div className="w-full md:w-3/4 grid">
                    <Controller
                      name="usuario_telefone"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <InputText
                          value={value}
                          onChange={({ target }) =>
                            onChange(
                              mask(unMask(target.value), [
                                '(99) 9999-9999',
                                '(99) 99999-9999'
                              ])
                            )
                          }
                          id="usuario_telefone"
                          type="text"
                        />)}
                    />
                  </div>
                </div>
                <div className="grid md:flex p-2 items-center">
                  <label htmlFor="tipo_empresa" className="w-full mb-2 md:w-1/4 md:mb-0">Tipo de Empresa</label>
                  <div className="w-full md:w-3/4 grid">
                    <InputText
                      {...register("tipo_empresa")}
                      id="tipo_empresa"
                    />
                  </div>
                </div>
                <div className="grid md:flex p-2 items-center">
                  <label htmlFor="usuario_senha" className="w-full mb-2 md:w-1/4 md:mb-0">Senha</label>
                  <div className="w-full md:w-3/4 grid">
                    <Controller
                      name="usuario_senha"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <Password
                          toggleMask
                          required
                          pt={PasswordFullPague}
                          feedback={false}
                          value={value}
                          onChange={(e) => onChange(e.target.value)}
                          id="usuario_senha"
                        />)}
                    />
                  </div>
                </div>
                <div className="grid md:flex p-2 items-center">
                  <label htmlFor="confirma_usuario_senha" className="w-1/2 mb-2 md:w-1/4 md:mb-0">Confirmar Senha</label>
                  <div className="w-full md:w-3/4 grid">
                    <Controller
                      name="confirma_usuario_senha"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <Password
                          toggleMask
                          required
                          pt={PasswordFullPague}
                          feedback={false}
                          value={value}
                          onChange={(e) => onChange(e.target.value)}
                          id="confirma_usuario_senha"
                        />)}
                    />
                  </div>
                </div>
              </div>
              <div className="w-full flex justify-center">
                <div className="w-full md:w-3/4 lg:w-1/3">
                  <Button
                    className="w-full"
                    pt={ButtonPagueDefault}
                    label="Enviar"
                    type="submit"
                    loading={loadingProvider}
                  ></Button>
                </div>
              </div>
            </div>
          </form>

        </AppCard>
        )}
    </div>
  </>
  )
}
